<template>
  <div>
    <AlertDismiss ref="alertDismiss"></AlertDismiss>

    <p class="text-muted mb-3">
      Ingresa tu correo electrónico para resetear su contraseña.
    </p>

    <b-form @submit="onSubmit">
      <b-form-group
        class="mb-3"
        id="input-group-email"
        label="Correo electrónico"
      >
        <b-form-input
          id="input-email"
          v-model="form.email"
          type="email"
          placeholder="Ejemplo@dominio.com"
          required
          autocomplete="email"
        >
        </b-form-input>
      </b-form-group>

      <div>
        <b-button
          class="me-2"
          type="submit"
          variant="primary"
          :disabled="process || !form.email"
        >
          <b-spinner v-if="process" small />
          Enviar nueva contraseña
        </b-button>

        <b-button
          variant="outline-secondary"
          @click="goBack"
          :disabled="process"
        >
          Volver
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import AlertDismiss from "@/components/shared/Alert-dismiss.vue";

export default {
  name: "ForgotPasswordForm",

  data() {
    return {
      form: {
        email: "",
      },
      process: false,
    };
  },

  components: {
    AlertDismiss,
  },

  mounted() {
    // Auto-focus on email input
    this.$nextTick(() => {
      document.getElementById("input-email")?.focus();
    });
  },

  methods: {
    ...mapActions(["forgottenPassword"]),

    async onSubmit(event) {
      event.preventDefault();
      this.processing();

      try {
        const result = await this.forgottenPassword(this.form.email);

        if (result.isError) {
          this.$refs.alertDismiss.showAlert(result.message);
          this.processing();
          return;
        }

        // Show success message regardless of whether email exists
        this.$refs.alertDismiss.showAlert(
          "Si el correo electrónico esta registrado, recibirá una nueva contraseña.",
          "success"
        );
        this.processing();

        // Auto redirect to login after 5 seconds
        setTimeout(() => {
          this.goBack();
        }, 5000);
      } catch (error) {
        this.$refs.alertDismiss.showAlert(
          "Error al procesar la solicitud. Inténtalo nuevamente."
        );
        this.processing();
      }
    },

    goBack() {
      // Reset form state when going back
      this.form.email = "";
      this.$emit("goBack");
    },

    processing() {
      this.process = !this.process;
    },
  },
};
</script>

<style scoped>
.alert {
  border-radius: 0.375rem;
}
</style>
